import { render, staticRenderFns } from "./CompanyMenuFoodOrderCard.vue?vue&type=template&id=571a657e&scoped=true"
import script from "./CompanyMenuFoodOrderCard.vue?vue&type=script&lang=js"
export * from "./CompanyMenuFoodOrderCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenuFoodOrderCard.vue?vue&type=style&index=0&id=571a657e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a657e",
  null
  
)

export default component.exports